"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotherStatusBadge = MotherStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../../table");
function MotherStatusBadge(props) {
    var _a;
    var status = props.status;
    var STATUS_COLORS = {
        ACTIVE: "green-soft",
        REGENERATION: "blue",
        BACKUP: "gray",
        QUARANTINE: "amber",
        RETIRED: "red",
        REMOVED: "red-solid",
    };
    if (!status) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: (_a = STATUS_COLORS[status]) !== null && _a !== void 0 ? _a : "navy", children: status });
}
